import React from "react";
import { SketchPicker } from "react-color";
import { useDispatch, useSelector } from "react-redux";
// import { editDetailsLocalOnly } from "../../../store/reducers/authReducer";

const SketchColorPalette = (props) => {
  const { user } = useSelector((state) => state.authReducer);
  const dispatch = useDispatch();
  // const setMainColor1 = (color) => {
  //   // dispatch(editDetailsLocalOnly({ [props.change]: color }));
  // };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        width: "100%",
      }}
    >
      {props.div}
      {props.display && (
        <div
          style={{
            bottom: "50px",
            position: "absolute",
            left: "-11px",
            zIndex: 1,
            // paddingBottom: "10px",
            background:
              "radial-gradient(circle, #f2f2f2 0%, rgba(255,255,255,0.2) 100%)",
            // padding: "10px",
            // backdropFilter: "blur(20px)",
          }}
        >
          <SketchPicker
            disableAlpha={true}
            style={{ width: "200px", border: "1px solid black" }}
            color={props.color}
            onChange={(c) =>
              props.color2change(
                "#" +
                  ((1 << 24) + (c.rgb.r << 16) + (c.rgb.g << 8) + c.rgb.b)
                    .toString(16)
                    .slice(1)
              )
            }
          />
        </div>
      )}
    </div>
  );
};

export default SketchColorPalette;
